import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAccountApprovalsPreference } from 'services/ApprovalsService'
import { AccountApprovalsPreferenceError } from 'types/approvals'

export const useAccountApprovalsPreferenceQuery = (
  parentId: string,
  preference?: string,
  flow?: string
) => {
  return useQuery(
    reactQueryKeys.accountApprovalsPreference(preference, flow, parentId),
    () => getAccountApprovalsPreference(preference, flow, parentId),
    {
      onError: (error: AccountApprovalsPreferenceError) =>
        logSentryError(
          'Error from useAccountApprovalsPreferenceQuery - getAccountApprovalsPreference',
          error
        ),
    }
  )
}
